import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy-950 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1nbbzzw4fnuo7">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-166" data-mp="1ncmzvkurcia1">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-silver-300 bg-navy-800 shadow-2xl shadow-black/40" data-id="element-167" data-mp="1x8gnbza0lw6l">
          <div className="flex items-center justify-between gap-4 border-b border-silver-400/20 bg-navy-700 px-6 py-4 sm:px-10" data-id="element-168" data-mp="227b4kwsc3col">
            <span className="metal inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-navy-950" data-id="element-169" data-mp="2x1v9btj7kno">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="1mi9950k30si7" /> Main offer
            </span>
            <span className="text-xs font-bold uppercase tracking-[.14em] text-silver-200" data-id="element-171" data-mp="1hodeo8311nrs">Launch price today</span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-172" data-mp="1coin02bfgu5o">
            <div className="flex flex-col gap-6 border-b border-silver-400/15 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-173" data-mp="17sjuq3mzarzz">
              <div data-id="element-174" data-mp="25f0pp288otik">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-175" data-mp="25dg3bzw2wgvs">{productShortName}</h3>
                <p className="mt-2 text-sm text-silver-300" data-id="element-176" data-mp="20emrsd0cqzy9">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-177" data-mp="k27px1n15bdm">
                <span className="text-sm text-silver-300" data-id="element-178" data-mp="k3r6ktcllofx">
                  Regular price <span className="line-through" data-id="element-179" data-mp="g0cm9qhmmlwo">{priceBefore}</span>
                </span>
                <p className="metal-text mt-1 whitespace-nowrap text-5xl font-extrabold" data-id="element-180" data-mp="hh887911hv5f">{price}</p>
                <p className="text-xs font-bold uppercase tracking-[.14em] text-silver-400" data-id="element-181" data-mp="mh4fpi8y44pq">Today</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="7j2dpchkbral">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-silver-100" data-id="element-183" data-mp="cgu23wj00va1">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-184" data-mp="3uul5aufjjvhl" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-185" data-mp="3l01klii30dy0">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silver-300" data-id="element-186" data-mp="3bxjyr56c9nbj">
              <span className="inline-flex items-center gap-1.5" data-id="element-187" data-mp="3fy3x2c2newz9">
                <LockIcon className="h-4 w-4 text-silver-200" aria-hidden="true" data-id="element-188" data-mp="2xala1hyv970i" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-189" data-mp="2sd1u8dmism6g">
                <ZapIcon className="h-4 w-4 text-silver-200" aria-hidden="true" data-id="element-190" data-mp="36bjg05sv7olq" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="31cf77g9ursvx">
                <ShieldCheckIcon className="h-4 w-4 text-silver-200" aria-hidden="true" data-id="element-192" data-mp="31f1av4tmho8v" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-silver-400" data-id="element-193" data-mp="3b9tbyimeyt8e">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}